import { render, staticRenderFns } from "./AssociateChild.vue?vue&type=template&id=34f7660e&"
import script from "./AssociateChild.vue?vue&type=script&lang=js&"
export * from "./AssociateChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports